import React, { Component } from 'react';

export class NoTicketPopover extends Component{

    buttonClickHandler = () => {
        const { registrationsUrl, openCloseTicketSelectionPopUp } = this.props;
        openCloseTicketSelectionPopUp();
        window.open(registrationsUrl, '_top');
    }

    differentAccountLinkClick = () => {
        const { signedOutUserReact, openCloseTicketSelectionPopUp } = this.props;
        openCloseTicketSelectionPopUp();
        signedOutUserReact(true);
    }


    render() {
        const {
            className,
            style: {
                top,
                left
            },
            arrowOffsetLeft = null,
            arrowOffsetTop = null,
            positionTop,
            positionLeft,
            userData: {
                primaryEmail
            },
            openCloseTicketSelectionPopUp,
            registrationsUrl,
            signedOutUserReact,
            ...rest
        } = this.props;

        return (
            <div
                className={`no-ticket-popover ${className}`}
                style={{top, right: 0}}
                {...rest}>
                <div className='popover-arrow-custom' />
                <div className='main-section' >
                    <div className='ticket-image' />
                    <div className='popup-title'>
                        <span>No tickets are associated</span>
                        <br/>
                        <span>with your account</span>
                    </div>
                    <div className="info-section">
                        <div>
                            The following email:
                            <span className='user-email'>{` ${primaryEmail}`}</span>
                        </div>
                        <div>isn’t associated with this event.</div>
                        <div>Register or try a different email in order to</div>
                        <div>save a seat in session.</div>
                    </div>
                    <button
                        className='register-button  color-1-background'
                        onClick={this.buttonClickHandler}>
                        REGISTER
                    </button>
                    <div className='link-different-email'>
                        <a onClick={this.differentAccountLinkClick}>Try different email </a>
                    </div>
                </div>
            </div>
        );
    }
}
